module.exports = __webpack_public_path__ + "img/Banner-BlueprintRolls-dwnszd.5007b544.jpg";